var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnswerCall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 82,
    viewBox: "0 0 94 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.80005,
    y: 7,
    width: 79.1521,
    height: 67.1319,
    rx: 33.566,
    fill: "#2EDC35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.30005,
    y: 3.5,
    width: 86.1521,
    height: 74.1319,
    rx: 37.066,
    stroke: "#2EDC35",
    strokeOpacity: 0.15,
    strokeWidth: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4252 49.0041V54.0143C64.4271 54.4794 64.3318 54.9398 64.1455 55.3659C63.9592 55.7921 63.6859 56.1746 63.3432 56.489C63.0004 56.8035 62.5958 57.0429 62.1552 57.1919C61.7146 57.3409 61.2477 57.3962 60.7845 57.3544C55.6455 56.796 50.7091 55.0399 46.372 52.2273C42.3369 49.6632 38.9159 46.2422 36.3518 42.2071C33.5294 37.8502 31.7729 32.8899 31.2247 27.7278C31.183 27.2659 31.2379 26.8005 31.3859 26.361C31.5339 25.9216 31.7718 25.5178 32.0844 25.1753C32.397 24.8328 32.7776 24.5592 33.2017 24.3719C33.6259 24.1845 34.0844 24.0875 34.5481 24.0871H39.5583C40.3687 24.0791 41.1545 24.3661 41.769 24.8946C42.3835 25.4231 42.7849 26.157 42.8983 26.9596C43.1098 28.5629 43.502 30.1372 44.0674 31.6524C44.2921 32.2501 44.3407 32.8998 44.2075 33.5243C44.0743 34.1488 43.7649 34.7221 43.3159 35.1762L41.1949 37.2971C43.5723 41.4782 47.0341 44.94 51.2152 47.3174L53.3361 45.1964C53.7902 44.7474 54.3635 44.438 54.988 44.3048C55.6125 44.1716 56.2622 44.2202 56.8599 44.4449C58.3751 45.0103 59.9494 45.4025 61.5527 45.6139C62.364 45.7284 63.1049 46.137 63.6345 46.7621C64.1641 47.3872 64.4455 48.1851 64.4252 49.0041Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.8,
    y: 17,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerCall);
export default __webpack_public_path__ + "static/media/answerCall.24f83c42df60ccc2c07e36e8de89de32.svg";
export { ForwardRef as ReactComponent };